"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DotApiAuthorization = void 0;
const tslib_1 = require("tslib");
const cross_fetch_1 = require("cross-fetch");
function getErrorMessage(data) {
    if (data.errors) {
        return data.errors[0].message;
    }
    if (data.error) {
        return data.error;
    }
}
/**
 * DotCMS Authentication handler to intereact with  {@link https://dotcms.com/docs/latest/rest-api-authentication | Authentication API}
 *
 */
class DotApiAuthorization {
    /**
     * Given user, password and expiration date to get a DotCMS Autorization Token
     */
    getToken(params) {
        const { user, password, expirationDays, host } = params;
        return (0, cross_fetch_1.default)(`${host || ''}/api/v1/authentication/api-token`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                user: user,
                password: password,
                expirationDays: expirationDays || 10
            })
        }).then((res) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = yield res.json();
            if (res.status === 200) {
                return data.entity.token;
            }
            throw {
                message: getErrorMessage(data),
                statusCode: res.status
            };
        }));
    }
}
exports.DotApiAuthorization = DotApiAuthorization;
